module.exports = __webpack_public_path__ + "static/img/france.78e9f99.png";